import { FormControl, FormLabel } from "@chakra-ui/react";
import { type ChainFullId, tezToMutez } from "@umami/chains";

import { TezTile } from "../../../AssetTiles/TezTile";

type AmountPreviewFieldProps = {
  chainId: ChainFullId;
  amount: string;
};

export const AmountPreviewField = ({ chainId, amount }: AmountPreviewFieldProps) => (
  <FormControl>
    <FormLabel width="full">Amount</FormLabel>
    <TezTile chainId={chainId} mutezAmount={tezToMutez(amount).toString()} />
  </FormControl>
);
